import React from "react";
import Typography from "@material-ui/core/Typography";

const copyrightStyle = {
    padding: "5px 0"
};
export default props => (
    <Typography style={copyrightStyle} variant="body2" color="textSecondary" align="center" className="copyright">
        {"Copyright © "}
        <a href="https://handsonbooking.dk/">handsonbooking.dk</a> {new Date().getFullYear()}
        {". Version 2.0.1."}{" "}
        <a
            href="/pdf/Handelsbetingelser Handson Booking.pdf"
            target="_blank"
            style={{ borderBottom: "1px solid #4d5ccc", color: "#4d5ccc", fontWeight: 500 }}
            rel="noopener noreferrer">
            Handelsbetingelser
        </a>{" "}
        <a
            href="/pdf/Datapolitik HandsOnBooking.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{ borderBottom: "1px solid #4d5ccc", color: "#4d5ccc", fontWeight: 500 }}>
            Persondatapolitik
        </a>
    </Typography>
);
